export default __webpack_public_path__ + "static/media/logo_DNA_Mali-removebg-preview.c69b6c2c.png";